import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { SecondOpinionPage } from "@/pages/second-opinion";

export const Route = createFileRoute("/$lang/independent-review")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/second-opinion",
      title: t("second-opinion.title"),
      description: t("second-opinion.description"),
    });
  },
  component: SecondOpinionPage,
});
